import React from 'react';
import { Bell } from 'lucide-react';

const NotificationBell: React.FC = () => {
  return (
    <button
      type="button"
      className="rounded-2xl border border-slate-200 dark:border-neutral-700 bg-white dark:bg-neutral-800 px-2.5 py-1.5 text-sm hover:bg-slate-50 dark:hover:bg-neutral-700 text-neutral-700 dark:text-neutral-300"
      aria-label="Notifications"
      title="Notifications"
    >
      <Bell className="h-4 w-4" />
    </button>
  );
};

export default NotificationBell;

